import { render, staticRenderFns } from "./20.vue?vue&type=template&id=1501902f&scoped=true&"
var script = {}
import style0 from "./20.vue?vue&type=style&index=0&id=1501902f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1501902f",
  null
  
)

export default component.exports